module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUzNy40IDM2Mi4zbDIuMiAyLjUgMjQ5LjkgMjQ3YzEzLjkgMTMuOCAxMy45IDM2LjEgMCA0OS45YTM2IDM2IDAgMCAxLTQ3LjEgMi45bC0zLjQtM0w1MTIgNDM3LjNsLTIyNyAyMjQuNGEzNiAzNiAwIDAgMS00Ny4xIDNsLTMuNC0zYTM1IDM1IDAgMCAxIDAtNDkuOWwyNDkuOS0yNDcgMi4zLTIuNWM2LjQtNi40IDE0LjctOS44IDIzLjEtMTAuM2g0LjVjNyAwLjQgMTQgMi44IDE5LjggNy4zbDMuNCAyLjl6IiBmaWxsPSIjMCIgcC1pZD0iNzYzIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Chevron up-outlined.svg
// module id = T+5O
// module chunks = 74